// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"7d28b083","128":"4315457f","228":"ed045acf","512":"1f739ae9","568":"2b523181","600":"22281d67","640":"08d92b4c","672":"93b31fdc","916":"8a8f1668","960":"e55573b5","976":"b5385203"}[chunkId] + ".chunk.js";
};